import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setAlert } from 'src/appRedux/actions'; // alertMsg를 초기화하는 액션
import AlertWarning from "../../assets/svg/AlertWarning";
import AlertInfo from "../../assets/svg/AlertInfo";
import AlertError from "../../assets/svg/AlertError";
import AlertSuccess from "../../assets/svg/AlertSuccess";

const iconMap = {
  info: AlertInfo,
  warning: AlertWarning,
  error: AlertError,
  success: AlertSuccess,
};

const OverlayAlert = ({ duration = 2000 }) => {
  const dispatch = useDispatch();
  const { alertInfo } = useSelector(({ settings }) => settings);

  useEffect(() => {
    if (!alertInfo.msg) return;

    const timer = setTimeout(() => {
      dispatch(setAlert({})); // alertMsg 초기화
    }, duration);

    return () => clearTimeout(timer);
  }, [alertInfo, duration, dispatch]);

  // alertMsg 없으면 렌더링 안 함
  if (!alertInfo.msg) return null;

  const IconComponent = iconMap[alertInfo.level] || AlertInfo;

  return createPortal(
    <div
      id="custom-alert"
      style={{
        position: 'fixed',
        top: '10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(24, 24, 24, 0.8)',
        color: '#D9D9D9',
        padding: '12px 24px',
        borderRadius: '4px',
        boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        zIndex: 9999,
        fontSize: 16,
        backdropFilter: 'blur(2px)',
        pointerEvents: 'none',
      }}
    >
      <IconComponent style={{ marginRight: 15, color: '#ff4d4f', fontSize: 20 }} />
      {alertInfo.msg}
    </div>,
    document.body
  );
};

export default OverlayAlert;
